import ClockFillSvg from '@assets/images/svg/clock-fill.svg';
import React from 'react';
import { View } from 'react-native';

export interface ClockFillIconProps {
    size?: number;
    color?: string;
}

export function ClockFillIcon({ size = 30, color = '#FAC12D' }: ClockFillIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ClockFillSvg width={size} height={size} color={color} />
        </View>
    );
}

export default ClockFillIcon;
